import { Modal, Button, Form, Table } from "react-bootstrap"
export default function InformationModal({ show, setShow, information }) {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            size={information?.informationType === "agency" ? "lg" : "md"}>
            <Modal.Header closeButton>
                <Modal.Title>{information?.informationType} Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {information?.informationType === "Agency" ? (
                        <div>
                            <Form>
                                {information?.data?.name ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Name</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.name}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.typeOfEntity ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Type</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.typeOfEntity}</Form.Text>
                                    </Form.Group>
                                ) : null}

                                {information?.data?.website ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Website</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.website}</Form.Text>
                                    </Form.Group>
                                ) : null}

                                {information?.data?.zipCode ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Zip Code</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.zipCode}</Form.Text>
                                    </Form.Group>
                                ) : null}

                                {information?.data?.phoneNumber ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Phone Number</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.phoneNumber}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.addressLine1 ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Address Line 1</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.addressLine1}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.addressLine2 ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Address Line 2</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.addressLine2}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.state ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>State</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.state}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.city ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>City</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.city}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {[true, false].includes(information?.data?.provideAdmittedProducerCode) ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Admitted Producer Code Provided?</strong>
                                        </Form.Label>
                                        <Form.Text>
                                            {information?.data?.provideAdmittedProducerCode ? "Yes" : "No"}
                                        </Form.Text>
                                    </Form.Group>
                                ) : null}
                            </Form>
                        </div>
                    ) : (
                        <div>
                            <Form>
                                {/* do same as above for firstName, lastName, email, userPhoneNumber, producerCode, active */}
                                {information?.data?.firstName ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>First Name</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.firstName}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.lastName ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Last Name</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.lastName}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.email ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Email</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.email}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.phoneNumber ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Phone Number</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.phoneNumber}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.agency ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Agency</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.agency}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.producerCode ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Un-Admitted Producer Code</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.producerCode}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.nyftzProducerCode ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>NYFTZ Producer Code</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.nyftzProducerCode}</Form.Text>
                                    </Form.Group>
                                ) : null}
                                {information?.data?.admittedProducerCode ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Admitted Code</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.admittedProducerCode}</Form.Text>
                                    </Form.Group>
                                ) : null}

                                {information?.data?.active ? (
                                    <Form.Group
                                        className="mb-3 d-flex flex-column"
                                        controlId="exampleForm.ControlInput1">
                                        <Form.Label>
                                            <strong>Active</strong>
                                        </Form.Label>
                                        <Form.Text>{information?.data?.active ? "Yes" : "No"}</Form.Text>
                                    </Form.Group>
                                ) : null}
                            </Form>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => setShow(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
